import React from 'react';
import sc from 'styled-components';
import { Col, Row } from 'antd';
import { BODY_FONT_FAMILY, px } from './styleConstants';

const FieldWrapper = sc.div`
    display: flex;
    flex-direction: column;
    justify-content:flex-end;
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
   
    justify-content: ${props => (props.tall ? 'flex-start' : 'center')};
    `;
const LabelWrapper = sc.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    justify-content: ${props => (props.tall ? 'flex-start' : 'center')};
    `;

const LabelTextWrapper = sc.span`
  width: 100%;
  font-family: ${BODY_FONT_FAMILY},
  font-weight: bold,
`;

const InputWrapper = sc.span`
    height: 100%;
     width: 100%;
`;

const FormField = ({ tall, children }) => (
  <FieldWrapper tall={tall}>
    <InputWrapper>
      {children}
    </InputWrapper>
  </FieldWrapper>
);

const FormLabel = ({ tall, children }) => (
  <LabelWrapper tall={tall}>
    <LabelTextWrapper>{children}</LabelTextWrapper>
  </LabelWrapper>
);

const FormRowFrame = sc.div`
${({ width }) => (width ? `width: ${px(width)};` : '')}
margin-bottom: ${({ bottomMargin }) => px(bottomMargin)}`;

const FormRow = ({
  height = 40, children, label, tall = false, minHeight,
  labelSpan = 8, gutter = 2, width = null, bottomMargin = '1rem',
}) => {
  let labelSpans = { span: labelSpan };
  if (typeof labelSpan === 'object') {
    labelSpans = labelSpan;
  }

  const rowStyle = {};

  if (minHeight) {
    rowStyle.minHeight = minHeight;
  } else if (height) {
    rowStyle.height = height;
  }

  // eslint-disable-next-line prefer-const
  let itemSpans = {};
  Object.keys(labelSpans).forEach((key) => {
    itemSpans[key] = 24 - labelSpans[key];
  });
  return (
    <FormRowFrame width={width} bottomMargin={bottomMargin}>
      <Row justify="space-around" align="middle" gutter={gutter} style={rowStyle}>
        <Col {...labelSpans} style={({ height: '100%' })}>
          <FormLabel tall={tall}>{label}</FormLabel>
        </Col>
        <Col {...itemSpans} style={({ height: '100%' })}>
          <FormField tall={tall}>{children}</FormField>
        </Col>
      </Row>
    </FormRowFrame>
  );
};

export { FormField, FormLabel, FormRow };
